const white = "#FFF";
// const darkWhite = "#F0F0F0"
// const black = "black"
const blackDarkest = "#171717";
const blackDark = "#222222";
const blackLight = "#2E2E2E";
// const blackLightest = "#6b6b6b"
const darkGrey = "#3b3b3b";
// const grey = "#666666";
// const greyWhite = "#D6D6D6"
// const green = "#75CE41"

export const lightTheme = {
  background: blackDark,
  backgroundLight: blackLight,
  color: white,
  borderBottom: "1px solid #222222",
  cancelButton: darkGrey,
  tabSelected:
    "transparent linear-gradient(90deg, #59AF26 0%, #7FDA48 100%) 0% 0% no-repeat padding-box;",
  tab: "#000000",
  tabHover: "#2B2B2C",
  refresh: blackDarkest,
  authBackground: "#050505",
  cardBackground: "#222222",
  cardInputBackground: "#2E2E2E",
};
export const darkTheme = {
  background: blackDark,
  backgroundLight: blackLight,
  color: white,
  borderBottom: "1px solid #222222",
  cancelButton: darkGrey,
  tabSelected:
    "transparent linear-gradient(90deg, #59AF26 0%, #7FDA48 100%) 0% 0% no-repeat padding-box;",
  tab: "#000000",
  tabHover: "#2B2B2C",
  refresh: blackDarkest,
  authBackground: "#050505",
  cardBackground: "#222222",
  cardInputBackground: "#2E2E2E",
};
